import React, {useState, useEffect, useCallback, forwardRef} from 'react';
import {
    Container,
    Button,
    Menu,
    Grid,
    GridColumn,
    Image,
    Header,
    FormField,
    Message,
    Form,
    Checkbox,
    TextArea,
    FormGroup,
    Dropdown,
    CardGroup,
    Card,
    CardContent,
    Icon,
    Dimmer,
    Loader,
    DimmerDimmable,
    Segment,
    Input
} from 'semantic-ui-react'
import {useSelector, useDispatch} from "react-redux";

import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik, setNestedObjectValues} from "formik";

import {
    inquiryGet,
    inquiryStart,
    inquirySave,
    inquiryGetMedia,
    inquiryCreateMedia,
    inquiryDeleteMedia
} from '../slices/register'

import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
//
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import {useDropzone} from "react-dropzone";
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import moment from 'moment'
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.us"

const GetStarted = (props) => {

    const dispatch = useDispatch();
    const [selectedMedias, setSelectedMedias] = useState([])
    const [selectedDelete, setSelectedDelete] = useState([])
    const [loading, setLoading] = useState(false)
    const [isReview, setIsReview] = useState(false)
    const [validationError, setValidationError] = useState(false)

    const {data, medias} = useSelector((state) => ({
        data: state.register.data,
        medias: state.register.medias,
    }));
    const formatMoney = (number, decPlaces, decSep, thouSep) =>  {
        let newDecSep = typeof decSep === "undefined" ? "." : decSep;
        let newDecPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces;
        let newThouSep = typeof thouSep === "undefined" ? "," : thouSep;
        let sign = number < 0 ? "-" : "";
        let i = String(
            parseInt((number = Math.abs(Number(number) || 0).toFixed(newDecPlaces)))
        );
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
            "$" +
            sign +
            (j ? i.substr(0, j) + newThouSep : "") +
            i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + newThouSep) +
            (newDecPlaces
                ? newDecSep +
                Math.abs(number - i)
                    .toFixed(newDecPlaces)
                    .slice(2)
                : "")
        );
    }
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {...data},
        validationSchema: Yup.object().shape({}),
        onSubmit: (values) => {
            let xxxlTotal = values.storage_items?.xxxl_items_count * values.storage_items?.xxxl_items_cost
            let xxlTotal = values.storage_items?.xxl_items_count * values.storage_items?.xxl_items_cost
            let xlTotal = values.storage_items?.xl_items_count * values.storage_items?.xl_items_cost
            let largeTotal = values.storage_items?.large_items_count * values.storage_items?.large_items_cost
            let mediumTotal = values.storage_items?.medium_items_count * values.storage_items?.medium_items_cost
            let smallTotal = values.storage_items?.small_items_count * values.storage_items?.small_items_cost

            let inquiryData = {...values}
            inquiryData.total_estimated_cost = xxxlTotal + xxlTotal + xlTotal + largeTotal + mediumTotal + smallTotal
            inquiryData.error = null
            dispatch(inquirySave(window.CONFIG.orgId, inquiryData.id, inquiryData, isReview, data => {
                if (data.error.show) {
                    window.scrollTo({top: 0, behavior: "smooth"})
                    if (data.error.errors && data.error.errors.length > 0) {
                        let validationError = {}
                        data.error.errors?.forEach(error => {
                            if (validationError[error.property]) {
                                if (Array.isArray(validationError[error.property])) {
                                    validationError[error.property] = [...validationError[error.property], error.message]
                                } else {
                                    validationError[error.property] = [validationError[error.property], error.message]
                                }
                            } else {
                                validationError[error.property] = error.message
                            }
                        })
                        setValidationError(validationError)
                    }
                    setLoading(false)
                } else {
                    window.scrollTo({top: 0, behavior: "smooth"})
                    setValidationError(false)
                    if (isReview) {
                        props.router.navigate('/review?id=' + data.id)
                    }
                }
            }))
        }
    });

    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    const handleDeleteMedia = useCallback(async (file) => {
        setSelectedDelete(file)
        await dispatch(inquiryDeleteMedia(window.CONFIG.orgId, data.id, file.id, async () => {
                await dispatch(inquiryGetMedia(window.CONFIG.orgId, data.id));
                setSelectedDelete(null)
            }
        ));
    }, [dispatch, data])

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"})
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);


    const orgId = window.CONFIG.orgId

    const onDrop = useCallback(async (acceptedFiles) => {
        setLoading(true)
        setSelectedMedias(acceptedFiles)
        for (const file of acceptedFiles) {
            await dispatch(inquiryCreateMedia(orgId, data.id, file.name, file, () => {
            }));
        }
        dispatch(inquiryGetMedia(
            orgId,
            data.id,
            () => {
                setSelectedMedias([])
                setLoading(false)
            }
        ));

    }, [dispatch, data])
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop, accept: {
            'image/jpeg': [],
            'image/png': [],
            'image/gif': [],
            'image/webp': [],

        }
    })

    useEffect(() => {
        const params = new URLSearchParams(props.router.location.search);
        const id = params.get("id")
        if (id) {
            dispatch(inquiryGet(window.CONFIG.orgId, id, () => {
                dispatch(inquiryGetMedia(window.CONFIG.orgId, id));
                setLoading(false)
            }))
        } else {
            dispatch(inquiryStart(window.CONFIG.orgId, () => {
                dispatch(inquiryGetMedia(window.CONFIG.orgId, "start"));
                setLoading(false)
                setSelectedMedias([])
            }))
        }
    }, [dispatch, props])

    const isMobile = width <= 768;

    let findValidationError = (object, child) => {
        let stringKey = child.replaceAll('_', ' ')
        return object && (Array.isArray(object) ? object.find(item => item.indexOf(stringKey) !== -1) : object.indexOf(stringKey) !== -1)
    }

    let estimatedPickupDate = validation.values?.estimated_pickup_date ? moment(validation.values.estimated_pickup_date, "MM-DD-YYYY") : null
    let estimatedDeliveryDate = validation.values?.estimated_delivery_date ? moment(validation.values.estimated_delivery_date, "MM-DD-YYYY") : null

    let billingContactSelected = validation.values?.billing_information?.billing_contact?.options && validation.values?.billing_information?.billing_contact?.options.find(item => item.selected) || null
    let xxxlTotal = validation.values.storage_items?.xxxl_items_count * validation.values.storage_items?.xxxl_items_cost
    let xxlTotal = validation.values.storage_items?.xxl_items_count * validation.values.storage_items?.xxl_items_cost
    let xlTotal = validation.values.storage_items?.xl_items_count * validation.values.storage_items?.xl_items_cost
    let largeTotal = validation.values.storage_items?.large_items_count * validation.values.storage_items?.large_items_cost
    let mediumTotal = validation.values.storage_items?.medium_items_count * validation.values.storage_items?.medium_items_cost
    let smallTotal = validation.values.storage_items?.small_items_count * validation.values.storage_items?.small_items_cost
    const ExampleCustomInput = forwardRef(
        ({ value, onClick, className }, ref) => (
            <input className={className} onClick={onClick} ref={ref} readOnly value={value}/>
        ),
    );
    return (
        <React.Fragment>
            {/*<Container style={{marginTop: '3em', alignContent: "center"}}>*/}
            <Grid doubling columns={"equal"}
                  style={{
                      padding: 20,
                      alignContent: "center",
                      paddingLeft: isMobile ? 20 : 100,
                      paddingRight: isMobile ? 20 : 100
                  }}>
                <GridColumn style={{
                    padding: 0,
                    paddingTop: 15,
                    textAlign: isMobile ? "center" : "initial",
                    display: "flex",
                    alignItems: "center"
                }}>
                    <Image style={{height: 50}} src={process.env.PUBLIC_URL + '/amston_commercial_logo_3Uv_icon.ico'}/>
                    <Header as={'h4'} style={{cursor: "pointer", margin: "0px 15px"}}>
                        Student Storage Request Form
                    </Header>
                </GridColumn>
            </Grid>
            <Menu inverted
                  style={{backgroundColor: "#990001", padding: 30, marginBottom: 0, borderRadius: 0}}>
                <Container style={{paddingTop: "3em"}}>
                    <Form onSubmit={async (e) => {
                        e.preventDefault();
                        const validationErrors = await validation.validateForm()
                        if (Object.keys(validationErrors).length > 0) {
                            validation.setTouched(setNestedObjectValues(validationErrors, true));
                            return;
                        }
                        validation.handleSubmit();
                        return false;
                    }}
                          action="#">

                        {Object.keys(validationError).map((key, index) => {
                            return <Message negative
                                            key={index}
                                            header={key.replaceAll('_', ' ').replace(/(^\w|\s\w)/g, firstCharOfWord => firstCharOfWord.toUpperCase())}
                                            content={Array.isArray(validationError[key]) ? validationError[key].map((err, index) => {
                                                return <p key={index}>{err}</p>
                                            }) : validationError[key]}/>
                        })}

                        {validation.values?.success?.show &&
                            <Message positive
                                     header={"Form Saved"}
                                     content={validation.values.success.message}/>}
                        <Header as={"h4"} style={{color: "white"}}>Student Information</Header>
                        <hr/>
                        <br/>
                        <FormGroup widths='equal'>
                            <FormField
                                error={findValidationError(validationError.student_information, "first_name") ? true : null}
                            >
                                <label>First Name<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='First Name'
                                       name={"first_name"}
                                       onChange={(e) => {
                                           let student_information = {...validation.values?.student_information}
                                           student_information.first_name = e.target.value
                                           validation.setFieldValue("student_information", student_information)
                                       }}
                                       value={validation.values.student_information?.first_name || ""}/>
                            </FormField>
                            <FormField
                                error={findValidationError(validationError.student_information, "last_name") ? true : null}
                            >
                                <label>Last Name<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='Last Name'
                                       name={"last_name"}
                                       onChange={(e) => {
                                           let student_information = {...validation.values?.student_information}
                                           student_information.last_name = e.target.value
                                           validation.setFieldValue("student_information", student_information)
                                       }}
                                       value={validation.values.student_information?.last_name || ""}/>
                            </FormField>
                        </FormGroup>
                        <FormGroup widths='equal'>
                            <FormField
                                error={findValidationError(validationError.student_information, "email") ? true : null}
                            >
                                <label>Email<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='Email'
                                       name={"email"}
                                       type={"email"}
                                       onChange={(e) => {
                                           let student_information = {...validation.values?.student_information}
                                           student_information.email = e.target.value
                                           validation.setFieldValue("student_information", student_information)
                                       }}
                                       value={validation.values.student_information?.email || ""}/>
                            </FormField>
                            <FormField
                                error={findValidationError(validationError.student_information, "phone_number") ? true : null}
                            >
                                <label>Phone Number<span
                                    className={"pull-right"}>*required</span></label>

                                <Cleave
                                    aria-label={"Phone Number"}
                                    className="form-control"
                                    id="validationTooltipPhone"
                                    name="phone_number"
                                    placeholder="xxxx xxx xxx"
                                    options={{
                                        phone: true,
                                        phoneRegionCode: "US",
                                        numericOnly: true
                                    }}
                                    inputmode="numeric"
                                    onChange={e => {
                                        let student_information = {...validation.values?.student_information}
                                        student_information.phone_number = e.target.value
                                        validation.setFieldValue("student_information", student_information)
                                    }}
                                    value={validation.values.student_information?.phone_number || ""}
                                />

                            </FormField>
                        </FormGroup>
                        <FormGroup widths='2'>
                            <FormField
                                error={findValidationError(validationError.student_information, "school_name") ? true : null}
                            >
                                <label>School University<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='School University'
                                       name={"school_name"}
                                       onChange={e => {
                                           let student_information = {...validation.values?.student_information}
                                           student_information.school_name = e.target.value
                                           validation.setFieldValue("student_information", student_information)
                                       }}
                                       value={validation.values.student_information?.school_name || ""}/>
                            </FormField>
                        </FormGroup>
                        <br/>
                        <Header as={"h4"} style={{color: "white"}}>Billing Contact (If Different)</Header>
                        <hr/>
                        <br/>
                        <FormGroup widths='2'>
                            <FormField
                                error={validationError.billing_contact ? true : null}
                            >
                                <label>Select Billing Contact</label>
                                <Dropdown
                                    scrolling
                                    fluid
                                    selection
                                    options={
                                        validation.values?.billing_information?.billing_contact?.options && validation.values?.billing_information?.billing_contact?.options.map((form, index) => {
                                            return {key: index, text: form.name, value: form.value}
                                        })}
                                    placeholder='Select one'
                                    onChange={(e, target) => {
                                        let billing_information = {...validation.values?.billing_information}
                                        let options = []
                                        billing_information.billing_contact.options.forEach(option => {
                                            let opt = {...option}
                                            if (opt.value === target.value) {
                                                opt.selected = true
                                            } else {
                                                opt.selected = false
                                            }
                                            options.push(opt)
                                        })
                                        billing_information.billing_contact = {
                                            ...billing_information.billing_contact,
                                            options
                                        }
                                        validation.setFieldValue("billing_information", billing_information)
                                    }}
                                    value={billingContactSelected && billingContactSelected?.value}
                                />
                                <br/>
                                <span style={{
                                    color: "white",
                                    fontSize: 13
                                }}> If you selected alternate billing contact please fill out information below</span>

                            </FormField>
                        </FormGroup>
                        <br/>
                        <FormField>
                            <label> Alternate Billing Contact</label>
                        </FormField>
                        <FormGroup widths='equal'>
                            <FormField
                                error={findValidationError(validationError.billing_demographics, "first_name") ? true : null}
                            >
                                <label>First Name</label>
                                <input placeholder='First Name'
                                       name={"first_name"}
                                       onChange={e => {
                                           let billing_information = {...validation.values?.billing_information}
                                           billing_information.billing_demographics = {
                                               ...billing_information.billing_demographics,
                                               first_name: e.target.value
                                           }
                                           validation.setFieldValue("billing_information", billing_information)
                                       }}
                                       value={validation.values.billing_information?.billing_demographics?.first_name || ""}/>
                            </FormField>
                            <FormField
                                error={findValidationError(validationError.billing_demographics, "last_name") ? true : null}
                            >
                                <label>Last Name</label>
                                <input placeholder='Last Name'
                                       name={"last_name"}
                                       onChange={e => {
                                           let billing_information = {...validation.values?.billing_information}
                                           billing_information.billing_demographics = {
                                               ...billing_information.billing_demographics,
                                               last_name: e.target.value
                                           }
                                           validation.setFieldValue("billing_information", billing_information)
                                       }}
                                       value={validation.values.billing_information?.billing_demographics?.last_name || ""}/>
                            </FormField>
                        </FormGroup>
                        <FormField
                            error={findValidationError(validationError.billing_demographics, "email") ? true : null}
                        >
                            <label>Email</label>
                            <input placeholder='Email'
                                   name={"email"}
                                   type={"email"}
                                   onChange={e => {
                                       let billing_information = {...validation.values?.billing_information}
                                       billing_information.billing_demographics = {
                                           ...billing_information.billing_demographics,
                                           email: e.target.value
                                       }
                                       validation.setFieldValue("billing_information", billing_information)
                                   }}
                                   value={validation.values.billing_information?.billing_demographics?.email || ""}/>
                        </FormField>
                        <FormField
                            error={findValidationError(validationError.billing_demographics, "phone_number") ? true : null}
                        >
                            <label>Contact Number</label>
                            <Cleave
                                aria-label={"Contact Number"}
                                className="form-control"
                                id="validationTooltipPhone"
                                name="phone_number"
                                placeholder="xxxx xxx xxx"
                                options={{
                                    phone: true,
                                    phoneRegionCode: "US",
                                    numericOnly: true
                                }}
                                inputmode="numeric"
                                onChange={e => {
                                    let billing_information = {...validation.values?.billing_information}
                                    billing_information.billing_demographics = {
                                        ...billing_information.billing_demographics,
                                        phone_number: e.target.value
                                    }
                                    validation.setFieldValue("billing_information", billing_information)
                                }}
                                value={validation.values.billing_information?.billing_demographics?.phone_number || ""}
                            />
                        </FormField>
                        <FormField
                            error={findValidationError(validationError.billing_demographics, "relationship") ? true : null}
                        >
                            <label>Relationship to Student</label>
                            <input placeholder='Relationship to Student'
                                   name={"relationship"}
                                   onChange={e => {
                                       let billing_information = {...validation.values?.billing_information}
                                       billing_information.billing_demographics = {
                                           ...billing_information.billing_demographics,
                                           relationship: e.target.value
                                       }
                                       validation.setFieldValue("billing_information", billing_information)
                                   }}
                                   value={validation.values.billing_information?.billing_demographics?.relationship || ""}/>
                        </FormField>
                        <br/>
                        <Header as={"h3"} textAlign='center' style={{color: "white"}}>Storage Item Selection</Header>
                        <hr/>
                        <p style={{color: "white"}}>
                            *In-room pick-up and delivery included -- Storage duration included, up to 4 months. Options
                            to
                            store longer or shorter -- Free Boxes & Tape for packing. Boxes are medium category price*
                        </p>
                        <br/>
                        <FormGroup widths='equal'>

                            <FormField>
                                <label>Small Items ($50 Per item/Per term (4 months of storage) </label>
                                <Dropdown
                                    scrolling={false}
                                    floating
                                    fluid multiple selection
                                    placeholder='Select one'
                                    name={"small_items"}
                                    options={validation.values.storage_items?.small_items?.options.map((form, index) => {
                                        return {key: index, text: form.name, value: form.value}
                                    })}
                                    onChange={(e, target) => {
                                        let storage_items = {...validation.values?.storage_items}
                                        let options = []
                                        console.log(target.value)
                                        storage_items.small_items.options.forEach(option => {
                                            let opt = {...option}
                                            if (target.value.indexOf(opt.value) !== -1) {
                                                opt.selected = true
                                            } else {
                                                opt.selected = false
                                            }
                                            options.push(opt)
                                        })
                                        storage_items.small_items = {
                                            ...storage_items.small_items,
                                            options
                                        }
                                        validation.setFieldValue("storage_items", storage_items)
                                    }}
                                    value={validation.values?.storage_items?.small_items?.options && validation.values?.storage_items?.small_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                />
                            </FormField>
                            <FormField
                                error={validationError.storage_items ? true : null}>
                                <label>Total # of Small items<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='0'
                                       type={"tel"}
                                       name={"small_items_count"}
                                       onChange={e => {
                                           let storage_items = {...validation.values?.storage_items}
                                           storage_items.small_items_count = isNaN(e.target.value * 1) ? 0 : e.target.value * 1
                                           validation.setFieldValue("storage_items", storage_items)
                                       }}
                                       value={validation.values.storage_items?.small_items_count || ""}/>
                            </FormField>
                        </FormGroup>
                        <FormGroup widths='equal'>

                            <FormField>
                                <label>Medium Items ($55 Per item/Per term (4 months of storage)</label>
                                <Dropdown
                                    scrolling={false}
                                    floating fluid multiple selection
                                    placeholder='Select one'
                                    name={"medium_items"}
                                    options={validation.values.storage_items?.medium_items?.options.map((form, index) => {
                                        return {key: index, text: form.name, value: form.value}
                                    })}
                                    onChange={(e, target) => {
                                        let storage_items = {...validation.values?.storage_items}
                                        let options = []
                                        storage_items.medium_items.options.forEach(option => {
                                            let opt = {...option}
                                            if (target.value.indexOf(opt.value) !== -1) {
                                                opt.selected = true
                                            } else {
                                                opt.selected = false
                                            }
                                            options.push(opt)
                                        })
                                        storage_items.medium_items = {
                                            ...storage_items.medium_items,
                                            options
                                        }
                                        validation.setFieldValue("storage_items", storage_items)
                                    }}
                                    value={validation.values?.storage_items?.medium_items?.options && validation.values?.storage_items?.medium_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                />
                            </FormField>
                            <FormField
                                error={validationError.storage_items ? true : null}>
                                <label>Total # of Medium Items<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='0'
                                       type={"tel"}
                                       name={"medium_items_count"}
                                       onChange={e => {
                                           let storage_items = {...validation.values?.storage_items}
                                           storage_items.medium_items_count = isNaN(e.target.value * 1) ? 0 : e.target.value * 1
                                           validation.setFieldValue("storage_items", storage_items)
                                       }}
                                       value={validation.values.storage_items?.medium_items_count || ""}/>
                            </FormField>
                        </FormGroup>
                        <FormGroup widths='equal'>

                            <FormField>
                                <label>Large Items ($65 Per item/Per term (4 months of storage)</label>
                                <Dropdown
                                    scrolling={false}
                                    floating fluid multiple selection
                                    placeholder='Select one'
                                    name={"large_items"}
                                    options={validation.values.storage_items?.large_items?.options.map((form, index) => {
                                        return {key: index, text: form.name, value: form.value}
                                    })}
                                    onChange={(e, target) => {
                                        let storage_items = {...validation.values?.storage_items}
                                        let options = []
                                        storage_items.large_items.options.forEach(option => {
                                            let opt = {...option}
                                            if (target.value.indexOf(opt.value) !== -1) {
                                                opt.selected = true
                                            } else {
                                                opt.selected = false
                                            }
                                            options.push(opt)
                                        })
                                        storage_items.large_items = {
                                            ...storage_items.large_items,
                                            options
                                        }
                                        validation.setFieldValue("storage_items", storage_items)
                                    }}
                                    value={validation.values?.storage_items?.large_items?.options && validation.values?.storage_items?.large_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                />
                            </FormField>
                            <FormField
                                error={validationError.storage_items ? true : null}>
                                <label>Total # of Large Items<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='0'
                                       type={"tel"}
                                       name={"large_items_count"}
                                       onChange={e => {
                                           let storage_items = {...validation.values?.storage_items}
                                           storage_items.large_items_count = isNaN(e.target.value * 1) ? 0 : e.target.value * 1
                                           validation.setFieldValue("storage_items", storage_items)
                                       }}
                                       value={validation.values.storage_items?.large_items_count || ""}/>
                            </FormField>
                        </FormGroup>
                        <FormGroup widths={2}>

                            <FormField>
                                <label>XL Items ($80 Per item/Per term (4 months of storage)</label>
                                <Dropdown
                                    scrolling={false}
                                    floating fluid multiple selection
                                    placeholder='Select one'
                                    name={"xl_items"}
                                    options={validation.values.storage_items?.xl_items?.options.map((form, index) => {
                                        return {key: index, text: form.name, value: form.value}
                                    })}
                                    onChange={(e, target) => {
                                        let storage_items = {...validation.values?.storage_items}
                                        let options = []
                                        storage_items.xl_items.options.forEach(option => {
                                            let opt = {...option}
                                            if (target.value.indexOf(opt.value) !== -1) {
                                                opt.selected = true
                                            } else {
                                                opt.selected = false
                                            }
                                            options.push(opt)
                                        })
                                        storage_items.xl_items = {
                                            ...storage_items.xl_items,
                                            options
                                        }
                                        validation.setFieldValue("storage_items", storage_items)
                                    }}
                                    value={validation.values?.storage_items?.xl_items?.options && validation.values?.storage_items?.xl_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                />
                            </FormField>
                            <FormField
                                error={validationError.storage_items ? true : null}>
                                <label>Total # of XL Items<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='0'
                                       type={"tel"}
                                       name={"xl_items_count"}
                                       onChange={e => {
                                           let storage_items = {...validation.values?.storage_items}
                                           storage_items.xl_items_count = isNaN(e.target.value * 1) ? 0 : e.target.value * 1
                                           validation.setFieldValue("storage_items", storage_items)
                                       }}
                                       value={validation.values.storage_items?.xl_items_count || ""}/>
                            </FormField>
                        </FormGroup>
                        <FormGroup widths='equal'>

                            <FormField>
                                <label>XXL Items ($125 Per item/Per term (4 months of storage)</label>
                                <Dropdown
                                    scrolling={false}
                                    floating fluid multiple selection
                                    placeholder='Select one'
                                    name={"xxl_items"}
                                    options={validation.values.storage_items?.xxl_items?.options.map((form, index) => {
                                        return {key: index, text: form.name, value: form.value}
                                    })}
                                    onChange={(e, target) => {
                                        let storage_items = {...validation.values?.storage_items}
                                        let options = []
                                        storage_items.xxl_items.options.forEach(option => {
                                            let opt = {...option}
                                            if (target.value.indexOf(opt.value) !== -1) {
                                                opt.selected = true
                                            } else {
                                                opt.selected = false
                                            }
                                            options.push(opt)
                                        })
                                        storage_items.xxl_items = {
                                            ...storage_items.xxl_items,
                                            options
                                        }
                                        validation.setFieldValue("storage_items", storage_items)
                                    }}
                                    value={validation.values?.storage_items?.xxl_items?.options && validation.values?.storage_items?.xxl_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                />
                            </FormField>
                            <FormField
                                error={validationError.storage_items ? true : null}>
                                <label>Total # of XXL Items<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='0'
                                       name={"xxl_items_count"}
                                       type={"tel"}
                                       onChange={e => {
                                           let storage_items = {...validation.values?.storage_items}
                                           storage_items.xxl_items_count = isNaN(e.target.value * 1) ? 0 : e.target.value * 1
                                           validation.setFieldValue("storage_items", storage_items)
                                       }}
                                       value={validation.values.storage_items?.xxl_items_count || ""}/>
                            </FormField>
                        </FormGroup>
                        <FormGroup widths='equal'>
                            <FormField>
                                <label>XXXL Items ($200 Per item/Per term (4 months of storage)</label>
                                <Dropdown
                                    scrolling={false}
                                    floating
                                    fluid multiple selection
                                    placeholder='Select one'
                                    name={"xxxl_items"}
                                    options={validation.values.storage_items?.xxxl_items?.options.map((form, index) => {
                                        return {key: index, text: form.name, value: form.value}
                                    })}
                                    onChange={(e, target) => {
                                        let storage_items = {...validation.values?.storage_items}
                                        let options = []
                                        storage_items.xxxl_items.options.forEach(option => {
                                            let opt = {...option}
                                            if (target.value.indexOf(opt.value) !== -1) {
                                                opt.selected = true
                                            } else {
                                                opt.selected = false
                                            }
                                            options.push(opt)
                                        })
                                        storage_items.xxxl_items = {
                                            ...storage_items.xxxl_items,
                                            options
                                        }
                                        validation.setFieldValue("storage_items", storage_items)
                                    }}
                                    value={validation.values?.storage_items?.xxxl_items?.options && validation.values?.storage_items?.xxxl_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                />
                            </FormField>
                            <FormField
                                error={validationError.storage_items ? true : null}>
                                <label>Total # of XXXL Items<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder='0'
                                       type={"tel"}
                                       name={"xxxl_items_count"}
                                       onChange={e => {
                                           let storage_items = {...validation.values?.storage_items}
                                           storage_items.xxxl_items_count = e.target.value * 1
                                           validation.setFieldValue("storage_items", storage_items)
                                       }}
                                       value={validation.values.storage_items?.xxxl_items_count || ""}/>
                            </FormField>
                        </FormGroup>

                        <br/>
                        <Header as={"h3"} textAlign='center' style={{color: "white"}}>Add Picture Items</Header>
                        <hr/>
                        <span
                            style={{color: "white", fontSize: 13}}>* Add images of your items here if available.</span>
                        <div
                            className={"dropzone dz-clickable"}>
                            <DimmerDimmable as={"div"} dimmed={loading}>
                                <div
                                    className="dz-message needsclick pt-4"
                                    {...getRootProps()}
                                >
                                    <input {...getInputProps()} />

                                    <div style={{textAlign: "center"}}>
                                        <Icon name='upload' size='huge' style={{color: "white"}}/>
                                    </div>
                                    <br/>
                                    {selectedMedias ?
                                        <CardGroup centered itemsPerRow={4} doubling>
                                            {selectedMedias.map((media, index) => {
                                                const objectUrl = URL.createObjectURL(media)
                                                return <Card key={index}>
                                                    <CardContent
                                                        className="text-center"
                                                        style={{
                                                            overflow: "hidden",
                                                            padding: 0,
                                                            backgroundColor: "aliceblue"
                                                        }}>
                                                        <img
                                                            src={objectUrl}
                                                            alt=""
                                                            style={{
                                                                width: 300,
                                                                height: 200,
                                                                objectFit: 'cover',
                                                                cursor: "pointer"
                                                            }}
                                                            className="img-fluid"
                                                        />
                                                    </CardContent>
                                                </Card>
                                            })
                                            }

                                        </CardGroup> : null
                                    }

                                    <Dimmer active={loading} page={false}>
                                        <Loader>Uploading</Loader>
                                    </Dimmer>
                                    {
                                        isDragActive ?
                                            <Header as={"h4"} textAlign='center' style={{color: "white"}}>Drop your
                                                images here!</Header> :
                                            <Header as={"h4"} textAlign='center' style={{color: "white"}}>Drag 'n' drop
                                                some files here, or click to select files</Header>
                                    }

                                </div>
                            </DimmerDimmable>
                        </div>

                        {/*<div {...getRootProps()}>*/}
                        {/*    <input {...getInputProps()} />*/}
                        {/*    <div*/}
                        {/*        className="mb-3">*/}
                        {/*        <i className="display-4 text-muted ri-upload-cloud-2-fill"/>*/}
                        {/*    </div>*/}
                        {/*    <h6>Drop file here or click to add picture of residence.</h6>*/}
                        {/*</div>*/}
                        {
                            medias ?
                                <CardGroup centered itemsPerRow={4} doubling>
                                    {medias.medias.map((media, index) => {
                                        return <DimmerDimmable key={index} as={Card}
                                                               dimmed={selectedDelete?.id === media.id}>
                                            <CardContent
                                                className="text-center"
                                                style={{
                                                    overflow: "hidden",
                                                    padding: 0,
                                                    backgroundColor: "aliceblue"
                                                }}>
                                                <Icon link name='times' color='black'
                                                      style={{
                                                          position: "absolute",
                                                          right: 5,
                                                          top: 5,
                                                          textShadow: "2px 2px 10px white"
                                                      }}
                                                      onClick={() => handleDeleteMedia(media)}/>
                                                <img
                                                    src={media.thumbnail_media_url}
                                                    alt=""
                                                    style={{
                                                        width: 300,
                                                        height: 200,
                                                        objectFit: 'cover',
                                                        cursor: "pointer"
                                                    }}
                                                    className="img-fluid"
                                                />

                                                <Dimmer active={selectedDelete?.id === media.id} page={false}>
                                                    <Loader>Deleting</Loader>
                                                </Dimmer>
                                            </CardContent>
                                        </DimmerDimmable>
                                    })
                                    }

                                </CardGroup> : null
                        }

                        <br/>
                        <FormGroup widths='2'>
                            <FormField
                                error={validationError.total_estimated_cost ? true : null}>
                                <label>Total Estimated Cost<span
                                    className={"pull-right"}>*required</span></label>
                                <input readOnly
                                       placeholder='Total Estimated Cost'
                                       name={"total_estimated_cost"}
                                       onChange={validation.handleChange}
                                       onBlur={validation.handleBlur}
                                       value={formatMoney(xxxlTotal + xxlTotal + xlTotal + largeTotal + mediumTotal + smallTotal)}
                                />
                            </FormField>
                        </FormGroup>
                        <FormField
                            label={"Misc. Items not listed or any other helpful information"}
                            rows={10}
                            control={TextArea}
                            name="misc_items_not_listed"
                            onChange={e => {
                                let storage_items = {...validation.values?.storage_items}
                                storage_items.misc_items_not_listed = e.target.value
                                validation.setFieldValue("storage_items", storage_items)
                            }}
                            value={validation.values.storage_items?.misc_items_not_listed || ""}
                        />

                        <FormField
                            error={validationError.estimated_pickup_date ? true : null}>
                            <label>Estimated Pick-up Date:<span
                                className={"pull-right"}>*required</span></label>
                            <DatePicker
                                slotProps={{ textField: { fullWidth: isMobile } }}
                                format="MM-DD-YYYY"
                                value={estimatedPickupDate}
                                onChange={(newValue) => {
                                    validation.setFieldValue("estimated_pickup_date", moment(newValue).format("MM-DD-YYYY"))
                                }}
                            />
                            <br/>
                            <span style={{
                                color: "white",
                                fontSize: 13
                            }}> Office will call to confirm schedule in advance</span>
                        </FormField>

                        <FormField
                            error={validationError.estimated_delivery_date ? true : null}>
                            <label>Estimated Delivery Date:<span
                                className={"pull-right"}>*required</span></label>
                            <DatePicker
                                slotProps={{ textField: { fullWidth: isMobile } }}
                                format="MM-DD-YYYY"
                                value={estimatedDeliveryDate}
                                onChange={(newValue) => {
                                    validation.setFieldValue("estimated_delivery_date", moment(newValue).format("MM-DD-YYYY"))
                                }}
                            />
                            <br/>
                            <span style={{
                                color: "white",
                                fontSize: 13
                            }}> Office will call to confirm schedule in advance</span>
                        </FormField>
                        <FormField
                            error={validationError.how_did_you_hear_about_us ? true : null}>
                            <label>How Did You Hear About Us<span
                                className={"pull-right"}>*required</span></label>
                        </FormField>
                        {validation.values.referral_information?.how_did_you_hear_about_us?.options.map((opt, index) => {
                            return <FormField
                                key={index}
                                error={validationError.how_did_you_hear_about_us ? true : null}>
                                <Checkbox label={opt.name}
                                          name={opt.name}
                                          value={opt.value}
                                          checked={opt.selected}
                                          onChange={(e, data) => {
                                              let referral_information = {...validation.values?.referral_information}

                                              let options = []
                                              referral_information.how_did_you_hear_about_us.options.forEach(option => {
                                                  let opt = {...option}
                                                  if (opt.value === data.value) {
                                                      opt.selected = data.checked
                                                  }
                                                  options.push(opt)
                                              })
                                              referral_information.how_did_you_hear_about_us = {
                                                  ...referral_information.how_did_you_hear_about_us,
                                                  options
                                              }
                                              validation.setFieldValue("referral_information", referral_information)
                                          }}
                                />
                            </FormField>
                        })}
                        <FormField
                            error={validationError.promotional_flyer_student_name ? true : null}>
                            <label>If you selected promotional flyer type name of student you received it from<span
                                className={"pull-right"}>*required</span></label>
                            <input placeholder=''
                                   name="promotional_flyer_student_name"
                                   onChange={e => {
                                       let referral_information = {...validation.values?.referral_information}
                                       referral_information.promotional_flyer_student_name = e.target.value
                                       validation.setFieldValue("referral_information", referral_information)
                                   }}
                                   value={validation.values.referral_information?.promotional_flyer_student_name || ""}/>
                            <span style={{color: "white", fontSize: 13}}> Type N/A if you selected another option</span>

                        </FormField>
                        <hr/>
                        <div style={{textAlign: 'center', paddingTop: "3em"}}>
                            <Button
                                className={'menu_button'}
                                disabled={!validation.isValid ? loading : false}
                                aria-label={'submit'}
                                type="submit"
                                style={{paddingLeft: 40, paddingRight: 40, margin: 30}}
                            >
                                Save
                            </Button>
                            <Button
                                className={'menu_button'}
                                disabled={!validation.isValid ? loading : false}
                                aria-label={'submit'}
                                onClick={async () => {
                                    setIsReview(true)
                                    validation.handleSubmit();
                                }}
                                style={{paddingLeft: 40, paddingRight: 40}}
                            >
                                Review Answer
                            </Button>
                        </div>
                    </Form>


                </Container>

            </Menu>

            <footer>
                <Grid doubling columns={"equal"}
                      style={{
                          paddingLeft: isMobile ? 10 : 100,
                          paddingRight: isMobile ? 10 : 100,
                          alignContent: "center"
                      }}>

                    <GridColumn style={{
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Header as={'h4'} style={{cursor: "pointer"}}>
                            <Image style={{height: 150, width: "auto"}}
                                   src={process.env.PUBLIC_URL + '/Amston-Commercial-Logo_512_Black_and_white.png'}/>
                        </Header>
                    </GridColumn>
                    <GridColumn style={{
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "initial",
                        float: "right"
                    }}>
                        <div style={{float: "right"}}>
                            <p className={"contact"}><Icon name='phone' size='large'/> (860) 920-5377</p>
                            <p className={"contact"}><Icon name='map pin' size='large'/> Wallingford, CT</p>
                            <p className={"contact"}><Icon name='mail' size='large'/> info @ amstonstudentstorage .com
                            </p>
                        </div>
                    </GridColumn>
                </Grid>
                <p>
                    Amston Student Storage 2025
                </p>
            </footer>
        </React.Fragment>
    );
};

export default withRouter(GetStarted);
